export default __webpack_public_path__ + "static/media/great.61b1f7f1.svg";